import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function FileArchives() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/file-archives" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="File archives" />
      <p>
        If you choose to download the whole release at once you will get a <strong>zip archive</strong>.
        <br />
        In order to get Mp3 files, you have to <strong>unzip</strong> the archive.
        <br />
        Right-click on the archive and choose <strong>extract files</strong>.
        <br />
        If you don&apos;t have a file archiver installed, we recommend using{' '}
        <a href="http://www.7-zip.org/" target="_blank" rel="noopener noreferrer">7ZIP</a>
      </p>

      <HelpContactUs subject={4} />
    </div>
  );
}
